import { facialAntiAging } from './initial/flow';

const FacialAntiAgingFlows = {
  facialAntiAging
};

export default FacialAntiAgingFlows;
